export default __webpack_public_path__ + "static/media/Play.51d61c83.svg";